export default __webpack_public_path__ + "static/challenge-4d3258dd672411ec8911dfadc5d83e40.webp";